import React from "react";
import { useInView } from "react-intersection-observer";
import classnames from "classnames";

export default function OnScrollAnimationWrapper(props) {
    const {
        children,
        animation,
        classNameWrapper,
        classNameInitialState,
        threshold = 0.2,
        ...otherProps
    } = props;

    const { ref, inView } = useInView({
        threshold,
        ...otherProps
    });

    return (
        <div
            ref={ref}
            className={classNameWrapper}>
            <div className={classnames(classNameInitialState, {
                [animation]: inView,
            })}>
                {children}
            </div>
        </div>
    );
}